import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function FolderLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.419 15.7321C21.419 19.3101 19.31 21.4191 15.732 21.4191H7.95C4.363 21.4191 2.25 19.3101 2.25 15.7321V7.93211C2.25 4.35911 3.564 2.25011 7.143 2.25011H9.143C9.861 2.25111 10.537 2.58811 10.967 3.16311L11.88 4.37711C12.312 4.95111 12.988 5.28911 13.706 5.29011H16.536C20.123 5.29011 21.447 7.11611 21.447 10.7671L21.419 15.7321Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.48047 14.463H16.2155"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
